module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BBREVIATIONS")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("1 Apol.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Justin Martyr, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("First Apology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("A(Y)B")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Anchor (Yale) Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ABRL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Anchor Bible Reference Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Aen.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vergil, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aeneid")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AIL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ancient Israel and Its Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("AJA")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("American Journal of Archaeology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ant.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Josephus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jewish Antiquities")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Apocr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Macarius Magnes, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Apocriticus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("APSP")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("American Philosophical Society Proceedings")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Argon.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Apollonius of Rhodes, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Argonautica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ASP")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("American Studies in Papyrology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ATANT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Abhandlungen zur Theologie des Alten und Neuen Testaments")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BDAG")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Danker, Frederick W., Walter Bauer, William F. Arndt, and F. Wilbur Gingrich. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Greek-English Lexicon of the New Testament and Other Early Christian Literature")]), _vm._v(". 3rd ed. Chicago: University of Chicago Press, 2000")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BETL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bibliotheca Ephemeridum Theologicarum Lovaniensium")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BibInt")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Biblical Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BibInt")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Biblical Interpretation Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BMSEC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Baylor–Mohr Siebeck Studies in Early Christianity")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Black’s New Testament Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BPC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Biblical Performance Criticism")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Biblical Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BTB")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Biblical Theology Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BTS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Biblical Tools and Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BZNW")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cat. Min.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Plutarch, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cato the Younger")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CBQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CCS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Classical Culture and Study")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CCSA")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Corpus Christianorum Series Apocryphorum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CCTC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cambridge Classical Texts and Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ClQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Classical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Comm. Jo.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Origen, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on the Gospel of John")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Comm. Matt.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Origen, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on the Gospel of Matthew")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cons.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Augustine, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Harmony of the Gospels")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cont")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Continuum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CSEL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Corpus Scriptorum Ecclesiasticorum Latinorum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CSML")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cambridge Studies in Medieval Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CUASEC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Catholic University of America Studies in Early Christianity")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Decr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Athanasius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Defense of the Nicene Definition")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dial.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Justin Martyr, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dialogue with Trypho")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("DJD")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Discoveries in the Judean Desert")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("EC")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Early Christianity")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ECC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Eerdmans Critical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ECL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Early Christianity and Its Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ESV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("English Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ETL")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ephemerides Theologicae Lovanienses")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("GCS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Die griechischen christlichen Schriftsteller der ersten [drei] Jahrhunderte")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gen. Rab.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Genesis Rabbah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Geogr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Strabo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Geography")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("GRM")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Graeco-Roman Memoirs")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("GTA")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Göttinger theologischer Arbeiten")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Haer.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Irenaeus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Against Heresies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Her.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who Is the Heir?")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Herm. Vis.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Shepherd of Hermas, Visions")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hist. eccl.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Eusebius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ecclesiastical History")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hom. Jo.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("John Chrysostom, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Homilies on John")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hom. Luc.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Origen, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Homilies on Luke")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HThKNT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Herders Theologischer Kommentar zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ICC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("International Critical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ICS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Illinois Classical Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ign. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eph.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ignatius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("To the Ephesians")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ign. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Magn.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ignatius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("To the Magnesians")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ign. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Smyrn.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ignatius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("To the Smyrnaeans")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ign. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trall.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ignatius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("To the Trallians")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("IJL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Interpreting Johannine Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Il.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Homer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Iliad")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Inst.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Quintilian, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Orator’s Education")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("J.W.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Josephus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jewish War")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Johannine Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JSHJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal for the Study of the Historical Jesus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSJSup")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to the Journal for the Study of Judaism")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal for the Study of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSNTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of the New Testament Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSRC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jerusalem Studies in Religion and Culture")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("LC")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Language and Communication")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LCL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Loeb Classical Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Leg.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Philo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Allegorical Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lives")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Diogenes Laertius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lives of Eminent Philosophers")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LNTS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Library of New Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LSJ")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Liddell, Henry George, Robert Scott, and Henry Stuart Jones. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Greek-English Lexicon")]), _vm._v(", 9th ed. with revised supplement. Oxford: Clarendon, 1996")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LSTS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Library of Second Temple Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Septuagint")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("m. Ber.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Mishnah Berakot")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mem")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Xenophon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Memorabilia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("MTSR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Method and Theory in the Study of Religion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nat.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pliny the Elder, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Natural History")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nat. orig.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Augustine, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Nature and Origin of the Soul")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NHMS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nag Hammadi and Manichaean Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NovT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Novum Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NovTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to Novum Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NRSV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Revised Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NTD")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Das Neue Testament Deutsch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NTGF")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The New Testament in the Greek Fathers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NTL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Testament Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NTMon")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Testament Monographs")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("New Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NTTh")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Testament Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NTTS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Testament Tools and Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NTTSD")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Testament Tools, Studies, and Documents")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("OCD")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oxford Classical Dictionary")]), _vm._v(". Edited by Simon Hornblower and Antony Spawforth. 4th ed. Oxford: Oxford University Press, 2012")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Od.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Homer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Odyssey")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OECGT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Oxford Early Christian Gospel Texts")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OECS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Oxford Early Christian Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("OOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hugo Grotius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Opera Omnia Theologica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Or.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Origen, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prayer")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("P.Oxy.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Oxyrhynchus Papyri")]), _vm._v(". Edited by Bernard P. Grenfell et al. London: Egypt Exploration Fund, 1898–")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Pan.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Epiphanius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Panarion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PG")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Patrologia Graeca. Edited by J.-P. Migne. 162 vols. Paris, 1857–1886")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Patrologia Latina. Edited by J.-P. Migne. 217 vols. Paris, 1844–1864")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pillar New Testament Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Prax.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tertullian, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Against Praxeas")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Princ.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Origen, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("First Principles")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ps.-Clem. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hom.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pseudo-Clementine, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Homilies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RB")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Revue biblique")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Review of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rhet.")]), _vm._v("]")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Dionysius of Halicarnassus, ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Art of Rhetoric")]), _vm._v("]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("RJT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Reception of Jesus in the First Three Centuries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("RSECW")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Routledge Studies in the Early Christian World")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLDS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sources chrétiennes")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SHGR")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studies in the History of Greece and Rome")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SJT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Scottish Journal of Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SMART")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Studies in Medieval and Renaissance Teaching")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SNTSMS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society for New Testament Studies Monograph Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SNTW")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studies of the New Testament and Its World")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SP")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sacra Pagina")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Spir.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Basil of Caesarea, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On the Holy Spirit")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("StBibLit")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studies in Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("StPatrSup")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studia Patristica Supplements")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Symp")]), _vm._v(".")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Xenophon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Symposium")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TAPA")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Transactions for the American Philological Association")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TBC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Torch Bible Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TENTS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Texts and Editions for New Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TLG")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Thesaurus Linguae Graecae")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Textes et traditions")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("UNT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Untersuchungen zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("VGPV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Veröffentlichungen der Gesellschaft Pro Vindonissa")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vir. ill.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jerome, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On Illustrious Men")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("VL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vetus Latina [Old Latin]")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("VTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to Vetus Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WGRW")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Writings from the Greco-Roman World")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WUNT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ZAW")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf6f51d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Abbreviations.vue
// module id = 78
// module chunks = 0